module.exports = __webpack_public_path__ + "static/location-c06d7a8bb3617695484b6431b18bda65.png";